
















































































































import { Component, Mixins, Prop, Emit } from 'vue-property-decorator';
import TextOutput from '~/mixins/TextOutput';
import SortDrawer from '~/components/SortDrawer.vue';
import BottomDrawerDialog from '~/components/UIComponents/BottomDrawerDialog.vue';
import { ISortOption } from '~/store/types';
import { IGalaStoreFilterOptions } from '~/types/gala-store';
import { GalaStoreToggleFilterCategory } from '../../types/gala-store';

@Component({ components: { SortDrawer, BottomDrawerDialog } })
export default class StoreFilterControls extends Mixins(TextOutput) {
  @Prop(String) readonly value!: string;
  @Prop(Array) readonly sortOptions!: ISortOption[];
  @Prop(Array) readonly currencyOptions!: ISortOption[];
  @Prop(Object) readonly selectedSort!: ISortOption;
  @Prop(Object) readonly selectedCurrency!: ISortOption;
  @Prop(Object) readonly filterOptions!: IGalaStoreFilterOptions;

  showSortDrawer = false;
  showSortDropDown = false;
  showCurrencyDrawer = false;
  showCurrencyDropDown = false;
  rebateSupportingCurrencies = [
    'Credit Card',
    'GUSDC',
    'GUSDT',
    'USDC',
    'USDT',
  ];
  showRebateMessage = false;

  get mobileView() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get appliedFilters() {
    return Object.values(this.filterOptions)
      .filter(value => value.field != GalaStoreToggleFilterCategory.name)
      .flatMap(value => value.values)
      .reduce((num, filter) => {
        if (filter.selected) num++;
        return num;
      }, 0);
  }

  get filteredCurrencyOptions() {
    const currencyBlacklist = ['CC-MOONPAY', 'CC'];
    return this.currencyOptions
      .filter(currency => !currencyBlacklist.includes(currency.title))
      .map(currency => {
        currency.displayTitle = this.getCurrencyTitle(
          currency.title,
        ).toString();
        return currency;
      });
  }

  getCurrencyTitle(slug: string) {
    const id = `components.store.storeFilterControls.${slug}`;
    if (!this.$te(id)) {
      return this.$t('components.store.storeFilterControls.currencyValue', {
        selectedCurrency: this.filterGyriText(slug),
      });
    } else {
      return this.filterGyriText(this.$t(id) as string);
    }
  }

  @Emit('currency-selected')
  handleCurrencySelected(currency: ISortOption) {
    setTimeout(() => {
      this.showCurrencyDrawer = false;
      this.showCurrencyDropDown = false;
    }, 300);
    return currency;
  }
  @Emit('sort-selected')
  handleSortSelected(sortOption: ISortOption) {
    setTimeout(() => {
      this.showSortDrawer = false;
      this.showSortDropDown = false;
    }, 300);
    return sortOption;
  }
}
